import AnalyzerAPP from "../components/Analyzerapp";


export default function Analyzer() {
 return <AnalyzerAPP/>;
}
